// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Tpc","questions":"styles_questions__EfNTa","footer":"styles_footer__-l_Kc"};